//bao migrate skip
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-number-box";
import "./../../services/bao-menu";
import "./../../bindings/validate";
import "./../../bindings/sorting";
import "./../../bindings/foreach-selection";
import "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import "./../../bindings/filtering";
import "./../../bindings/bao-upload";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import BaoDialog from "./../../factories/bao-dialog";
import Guid from "./../../factories/guid";
class ShiftbookTabUniversalFieldDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    public Model: any;
    UniversalfieldName: KnockoutObservable<string> = ko.observable("");
    UniversalFieldId: KnockoutObservable<string> = ko.observable("");
    Key: KnockoutObservable<string> = ko.observable("");
    ShiftTypeName: KnockoutObservable<string> = ko.observable("");
    ShiftTypeId: KnockoutObservable<string> = ko.observable("");
    ShiftbookTabId: KnockoutObservable<string> = ko.observable("");
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck;
    }
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        let result = true;
        if (Bao.Utils.String.IsNullOrWhitespace(this.UniversalfieldName())) {
            result = false;
        }
        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(result);
        return def.promise();
    };
}
export default ShiftbookTabUniversalFieldDialog;